import { render, staticRenderFns } from "./NewsTicker.vue?vue&type=template&id=e9cfb0dc&scoped=true"
import script from "./NewsTicker.vue?vue&type=script&lang=ts"
export * from "./NewsTicker.vue?vue&type=script&lang=ts"
import style0 from "./NewsTicker.vue?vue&type=style&index=0&id=e9cfb0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cfb0dc",
  null
  
)

export default component.exports